import React, { ComponentProps } from "react";
import { Props as InputShellProps } from "./InputShell";
import { cn } from "@/utils/cn";

export type Props = {
  onChange: (newValue: boolean) => void;
  value: boolean;
  className?: string;
  description?: string;
} & Omit<InputShellProps, "children"> &
  Omit<ComponentProps<"input">, "onChange" | "value">;

function Toggle({ label, onChange, value, className, subLabel, description, disabled }: Props) {
  return (
    <div className={cn("w-full rounded px-3 py-[1.375rem]", className)}>
      <label
        className={cn("flex cursor-pointer items-center space-x-3", disabled && "cursor-default")}
      >
        <input
          disabled={disabled}
          className={cn(
            "h-4 w-4 appearance-none rounded-[0.25rem] border-[#E3E6EB] accent-primary-base focus:outline-none focus:ring-0",
            disabled && "bg-gray-200"
          )} // TODO: CHECK WHY ACCENT DOES NOT WORK?
          type="checkbox"
          onChange={(e) => onChange(e.target.checked)}
          checked={!!value}
        />
        <div className="flex items-baseline gap-1 text-nowrap">
          <span className="text-dark text-sm font-normal">{label}</span>
          {subLabel && (
            <span className="text-xs font-normal italic text-[#6D7D96]">{subLabel}</span>
          )}
          {description && (
            <div className="flex items-baseline gap-1 text-nowrap">
              <span className="text-dark text-xs font-normal text-[#6D7D96]">{description}</span>
            </div>
          )}
        </div>
      </label>
    </div>
  );
}

export default Toggle;
